import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Domino } from '../models/domino_models';
import { DOMINO_DATA } from '../helpers/domino_data';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class DominoService {

  constructor(
    private http: HttpClient
  ) { }

  getQuestions(): Domino[]{
    return DOMINO_DATA;
  }

  createReport(directScore: number, naturalScore: number, answers: string[][]): Observable<any>{
    let obj = {
      directScore,
      naturalScore,
      answers
    }
    return this.http.post(`${environment.apiBaseUrl}/domino/createReport`, obj);
  }

  getReport(id: string): Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/domino/getReport/${id}`);
  }

  updateInterpretation(interpretation: any): Observable<any>{
    console.log(interpretation)
    return this.http.post(`${environment.apiBaseUrl}/domino/updateInterpretation`, interpretation, {headers: {'Content-Type': 'application/json'}});
  }

  getInterpretations(): Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/domino/getInterpretations`);
  }
  


}
